export default __webpack_public_path__ + "static/media/photo--sm--139.a5dd32d3.jpg";